import axios from './ajax/config';
import Comm from './comm';
import Constants from './constants';
import packageJson from "../package.json";

// const config = require('config/index.js');
let global = {};
global.setVue = function (value) {
  this.Vue = value;
};
global.getVue = function() {
  return this.Vue;
};
global.isVue3 = function() {
  if(this.Vue){
    return this.Vue.version.indexOf('3.') == 0;
  }
  return false;
};
global.isDisableRefreshToken = function(){
  if(Comm.isEmpty(this.refreshTokenUrl)){
    return true;
  } else {
    return false;
  }
};

global.setSubWindow = function () {
  sessionStorage.setItem(Constants.STORAGE_KEY_SUBWINDOW, 'Y');
};

global.isSubWindow = function () {
  let result = sessionStorage.getItem(Constants.STORAGE_KEY_SUBWINDOW);
  return result === 'Y';
};

global.setStaticHomePage = function(value){
  this.staticHomePage = value;
};

global.isStaticHomePage = function(){
  return this.staticHomePage === 'Y';
};

global.setStaticMenu = function(value){
  this.staticMenu = value;
};
global.isStaticMenu = function(){
  return this.staticMenu === 'Y';
};

global.setKeepAliveIncludeList = function(array){
  this.keepAliveIncludeList = array;
};

global.getKeepAliveIncludeList = function(){
  if(!this.keepAliveIncludeList){
    this.keepAliveIncludeList = [];
  }
  return this.keepAliveIncludeList;
};
global.setKeepAliveExcludeList = function(array){
  this.keepAliveExcludeList = array;
};

global.getKeepAliveExcludeList = function(){
  if(!this.keepAliveExcludeList){
    this.keepAliveExcludeList = [];
  }
  return this.keepAliveExcludeList;
};

global.setHeartBeatTriggers = function(params){
  if(Array.isArray(params)){
    localStorage.setItem(Constants.STORAGE_KEY_HEART_BEAT_TRIGGER, JSON.stringify(params));
  }
};
global.getHeartBeatTriggers = function(){
  let result = [];
  try {
    result = JSON.parse(localStorage.getItem(Constants.STORAGE_KEY_HEART_BEAT_TRIGGER));
  } catch (e) {
    result = [];
  }
  if(!result){
    result = [];
  }
  return result;
};

global.setRefreshTokenUrl = function (value) {
  this.refreshTokenUrl = value;
};

global.getRefreshTokenUrl = function () {
  if (this.refreshTokenUrl && this.refreshTokenUrl.toLowerCase().indexOf('http') == 0) {
    return this.refreshTokenUrl;
  } else {
    return this.getBaseUrl() + this.refreshTokenUrl;
  }
};

global.getBaseUrl = function () {
  if (!this.baseUrl) {
    let pathname = location.pathname.split('/');
    pathname.splice(pathname.length - 1, 1);
    let str = pathname.join('/');
    return location.protocol + '//' + location.host + str;
  } else if(this.baseUrl.toLowerCase().indexOf('//') == 0){
    return location.protocol + this.baseUrl;
  } else if(this.baseUrl.toLowerCase().indexOf('//') < 0){
    return this.getHostUrl() + this.baseUrl;
  } else {
    return this.baseUrl;
  }
};
global.getHostUrl = function () {
  let hostUrl = this.getCustomConfig()['KIAF_HOST_URL'];
  if(hostUrl && hostUrl.indexOf('//') >= 0){
    let arr = hostUrl.split('//');
    return (arr[0] || location.protocol) + '//' + arr[1];
  } else {
    if(this.baseUrl.indexOf('//') >= 0){
      let arr = this.baseUrl.split('//');
      let protocol = arr[0] || location.protocol;
      let nextUrl = arr[1];
      let arr2 = nextUrl.split('/');
      let host = arr2[0];
      return protocol + '//' + host;
    } else {
      return window.location.protocol + '//' + location.host;
    }
  }
};
global.getRootUrl = function () {
  return Comm.getHost();
};
global.setBaseUrl = function (value) {
  this.baseUrl = value;
};

global.setCloudRbacUrl = function (value) {
  this.cloudRbacUrl = value;
};

global.getCloudRbacUrl = function () {
  if(this.cloudRbacUrl && this.cloudRbacUrl.toLowerCase().indexOf('//') == 0){
    return location.protocol + this.cloudRbacUrl;
  } else if(this.cloudRbacUrl && this.cloudRbacUrl.toLowerCase().indexOf('//') < 0){
    return this.getHostUrl() + this.cloudRbacUrl;
  } else {
    return this.cloudRbacUrl;
  }
};

global.setWindows = function (windows) {
  windows.forEach(win => {
    if (win.url && win.url.indexOf('http') != 0 && win.url.split('?')[0].indexOf('#') < 0) {
      win.url = '/#' + win.url;
    }
  });
  localStorage.setItem(Constants.STORAGE_KEY_WINDOWS, JSON.stringify(windows));
};

global.getWindows = function () {
  let windows = JSON.parse(localStorage.getItem(Constants.STORAGE_KEY_WINDOWS));
  if (!windows) {
    windows = [];
  }
  return windows;
};

global.addSubWindow = function (subWindow) {
  let resultStr = localStorage.getItem(Constants.STORAGE_KEY_SUBWINDOWS);
  let result = [];
  if(resultStr){
    try {
      result = JSON.parse(resultStr);
    }catch (e) {
      result = [];
    }
  }
  result.push(subWindow);
  localStorage.setItem(Constants.STORAGE_KEY_SUBWINDOWS, JSON.stringify(result));
};

global.getSubWindows = function (subWindow) {
  let windows = JSON.parse(localStorage.getItem(Constants.STORAGE_KEY_SUBWINDOWS));
  if (!windows) {
    windows = [];
  }
  return windows;
};

global.setInitWindows = function (windows) { //保留最初的windows信息
  this.initWindows = windows;
};

global.getInitWindows = function () {
  return this.initWindows || [];
};

global.getPrimaryWindow = function(){
  let windows = this.getInitWindows();
  let result = [];
  windows.forEach(win => {
    if(win.primary){
      result.push(win);
    }
  });
  if(result.length > 0){
    return result[0];
  } else {
    return windows[0];
  }
};

global.getNoPrimaryWindows = function(){
  let windows = this.getInitWindows();
  let result = [];
  if(windows.length >= 2){
    windows.forEach(win => {
      if(!win.primary){
        result.push(win);
      }
    });
  }
  return result;
};

global.setPreloadMode = function (value) {
  sessionStorage.setItem(Constants.STORAGE_KEY_PRELOAD_MODE, value);
};

global.isPreloadMode = function () {
  return sessionStorage.getItem(Constants.STORAGE_KEY_PRELOAD_MODE) === 'Y';
};

global.setChromeExtWin = function (value) {
  sessionStorage.setItem(Constants.STORAGE_KEY_CHROME_EXT_WIN, value);
};

global.isChromeExtWin = function () {
  return sessionStorage.getItem(Constants.STORAGE_KEY_CHROME_EXT_WIN) === 'Y';
};

global.setScreenCount = function (value) {
  localStorage.setItem(Constants.STORAGE_KEY_SCREEN_COUNT, value);
};

global.getScreenCount = function () {
  let result = localStorage.getItem(Constants.STORAGE_KEY_SCREEN_COUNT);
  if(!result){
    result = 0;
  }
  return parseInt(result);
};

global.setPrimaryWindow = function (value) {
  sessionStorage.setItem('PRIMARY_WINDOW', value);
};

global.isPrimaryWindow = function () {
  let result = sessionStorage.getItem('PRIMARY_WINDOW');
  return result === 'Y';
};

global.setSessionWindowId = function(value) {
  sessionStorage.setItem(Constants.STORAGE_KEY_WINDOWID, value);
};

global.getSessionWindowId = function() {
  return sessionStorage.getItem(Constants.STORAGE_KEY_WINDOWID);
};

global.updateWindowUrl = function (windowId, to) {
  let windows = global.getWindows();
  let url = '';
  if(to.path){ // to is route
    url = to.path;
    for(let key in to.query){
      if(key){
        if(url.indexOf('?') < 0){
          url += '?' + key + '=' + encodeURIComponent(to.query[key]);
        } else {
          url += '&' + key + '=' + encodeURIComponent(to.query[key]);
        }
      }
    }
    if(!to.query[Constants.CODE_FULLSCREEN_PAGE]){
      global.setLatestPath(url);
    }
  } else { // to is url, not route
    url = to;
  }
  if(!global.getSessionWindowId()){
    windows.forEach(win => {
      if (win.url.indexOf(to.path) >= 0) {
        global.setSessionWindowId(win.windowId);
      }
    });
  } else if(!windowId){
    windowId = global.getSessionWindowId();
  }
  windows.forEach(win => {
    if (win.windowId === windowId) {
      if (url && url.indexOf('#') < 0) {
        win.url = '/#' + url;
      } else {
        win.url = url;
      }
    }
  });
  global.setWindows(windows);
};

global.setLatestPath = function (path) {
  sessionStorage.setItem(Constants.STORAGE_KEY_LATEST_PAGE, path);
};

global.getLatestPath = function() {
  return sessionStorage.getItem(Constants.STORAGE_KEY_LATEST_PAGE) || '';
};

global.isHorizontalLayout = function () {
  return Comm.getLayout() === 'H';
};

global.getAppName = function () {
  return Comm.getAppName();
};

global.getContentPath = function () {
  return Comm.getContentPath();
};

global.getOrgContentPath = function () {
  return Comm.getOrgContentPath();
};

global.isPopUp = function () {
  let result = (sessionStorage.getItem(Constants.STORAGE_KEY_POPUP_WINDOW) === 'Y');
  return result;
};

global.setPopUp = function (value, forceUpdate) {
  if(!sessionStorage.getItem(Constants.STORAGE_KEY_POPUP_WINDOW) || forceUpdate){ // 初始化赋值一次后就不再赋值（除非是强制更新），避免刷新把参数又还原成了global-xxx里的配置
    sessionStorage.setItem(Constants.STORAGE_KEY_POPUP_WINDOW, value);
  }
};

let clientSign = '';
global.getClientSign = function () {
  return clientSign;
};

global.setClientSign = function (value) {
  clientSign = value;
};
let sha256 = '';
global.setSha256 = function (value) {
  sha256 = value;
};

global.isSha256 = function () {
  return sha256 != 'N';
};
global.getEnv = function () {
  return Comm.getEnv();
  // let env = 'development';
  // if (process.env.NODE_ENV) {
  //   env = process.env.NODE_ENV;
  // }
  // return env;
};

let secretKey = '';
global.setSecretKey = function (value) {
  secretKey = value;
};

global.getSecretKey = function () {
  if (secretKey) {
    return secretKey;
  } else {
    return '@Kiaf123';
  }
};

let menuSign = '';
global.getMenuSign = function () {
  if (menuSign) {
    return menuSign;
  } else {
    return 'kd-kiaf-menu';
  }
};
global.setMenuSign = function (value) {
  menuSign = value;
};

global.getMenuType = function () {
  if (this.menuType) {
    return this.menuType;
  } else {
    return '';
  }
};
global.setMenuType = function (value) {
  this.menuType = value;
};

let menu = [];
global.setMenu = function (value) {
  if (Array.isArray(value)) {
    menu = value;
  }
};

global.getMenu = function () {
  return menu;
};

global.setMenuList = function (value) {
  if(Array.isArray(value)){
    localStorage.setItem(Constants.STORAGE_KEY_MENULIST, JSON.stringify(value));
  }
};

global.getMenuList = function () {
  try {
    let result = JSON.parse(localStorage.getItem(Constants.STORAGE_KEY_MENULIST));
    return result;
  }catch (e) {
    return [];
  }
};

// 设置当前用户禁止访问的页面路由
global.setForbiddenRoutes = function (value) {
  if (Array.isArray(value)) {
    this.forbiddenRoutes = value;
  }
};
// 获取当前用户禁止访问的页面路由
global.getForbiddenRoutes = function () {
  try {
    return this.forbiddenRoutes || [];
  }catch (e) {
    return [];
  }
}

global.setCustomConfig = function (value) {
  try {
    if (!value) {
      value = {};
    }
    localStorage.setItem(Constants.STORAGE_KEY_CUSTOM_CONFIG, JSON.stringify(value));
  } catch (e) {
  }
};

global.getCustomConfig = function () {
  let result = {};
  try {
    result = JSON.parse(localStorage.getItem(Constants.STORAGE_KEY_CUSTOM_CONFIG));
    if(!result){
      result = {};
    }
  } catch (e) {
    result = {};
  }
  return result;
};

global.setCustomApi = function (value) {
  try {
    if (!value) {
      value = {};
    }
    this.customApi = value;
  } catch (e) {
  }
};

global.getCustomApi = function (key) {
  try {
    if (!this.customApi) {
      this.customApi = {};
    }
    let url = '';
    for(let apiKey in this.customApi){
      if(key && apiKey.toLowerCase() == key.toLowerCase()){
         url = this.customApi[key];
         break;
      }
    }
    if(!Comm.isEmpty(url)){
      if(url.indexOf('http://') != 0 && url.indexOf('https://') != 0){ //包含了http的全路径
        url = this.getBaseUrl() + url;
      }
    }
    return url;
  } catch (e) {
  }
};

global.isSkipLogin = function () {
  if (this.skipLogin) {
    return this.skipLogin === 'Y';
  } else {
    return false;
  }
};
global.setSkipLogin = function (value) {
  this.skipLogin = value;
};

global.getWebviewList = function () {
  if(!this.webviewList){
    this.webviewList = [];
  }
  return this.webviewList;
};
global.addWebview = function (webviewId) {
  if(!this.webviewList){
    this.webviewList = [];
  }
  this.webviewList.push(webviewId);
};

global.removeWebview = function (webviewId) {
  if(!this.webviewList){
    this.webviewList = [];
  }
  for(let i = 0; i < this.webviewList.length; i++){
    if(this.webviewList[i] == webviewId){
      this.webviewList.splice(i, 1);
      break;
    }
  }
};

global.setWebviewMode = function (value) {
  if (value) {
    this.webviewMode = value.toUpperCase();
    if(this.webviewMode === 'APPPORTAL'){ //APPPORTAL模式会是一个新的tab窗口，需要考虑刷新会不会丢失数据
      sessionStorage.setItem(Constants.STORAGE_KEY_WEBVIEW_MODE, value.toUpperCase());
    }
  }
};
global.getWebviewMode = function () {
  return this.webviewMode || sessionStorage.getItem(Constants.STORAGE_KEY_WEBVIEW_MODE);
};
global.isExternalWebview = function () {
  return this.webviewMode === 'EXTERNAL';
  // return sessionStorage.getItem(Constants.STORAGE_KEY_WEBVIEW_MODE) === 'EXTERNAL';//从session里面读取，如果是内嵌自己的页面时，显示会有问题
};
global.isInternalWebview = function () {
  return this.webviewMode === 'INTERNAL';
};
global.isAppPortalWebview = function () {
  return this.webviewMode === 'APPPORTAL' || sessionStorage.getItem(Constants.STORAGE_KEY_WEBVIEW_MODE) === 'APPPORTAL';//APPPORTAL从session里面读取
};
global.getJwtToken = function() {
  let token = sessionStorage.getItem(Constants.STORAGE_KEY_JWT_TOKEN) || localStorage.getItem(Constants.STORAGE_KEY_JWT_TOKEN) || '';
  if(Comm.isEmpty(token) && this.isSkipLogin()){
    token = Constants.CODE_EMPTY_JWT_TOKEN;
  }
  return token;
};

global.setJwtToken = function(token) {
  if(token){
    let jwtToken = this.getJwtToken();
    for(let key in localStorage){ //同步更新到其他应用
      if(key.indexOf('_STORAGE_KEY_JWT_TOKEN') >= 0 && localStorage[key] == jwtToken){
        localStorage.setItem(key, token);
      }
    }
    for(let key in sessionStorage){ //同步更新到其他应用
      if(key.indexOf('_STORAGE_KEY_JWT_TOKEN') >= 0 && sessionStorage[key] == jwtToken){
        sessionStorage.setItem(key, token);
      }
    }
    if(this.isPopUp() || this.isChromeExtWin()){
      localStorage.setItem(Constants.STORAGE_KEY_JWT_TOKEN, token);
    }else{
      sessionStorage.setItem(Constants.STORAGE_KEY_JWT_TOKEN, token);
    }
  }
};

global.setRefreshToken = function(token) {
  let refreshTToken = this.getRefreshToken();
  for(let key in localStorage){ //同步更新到其他应用
    if(key.indexOf('_STORAGE_KEY_REFRESH_TOKEN') >= 0 && localStorage[key] == refreshTToken){
      localStorage.setItem(key, token);
    }
  }
  for(let key in sessionStorage){ //同步更新到其他应用
    if(key.indexOf('_STORAGE_KEY_REFRESH_TOKEN') >= 0 && sessionStorage[key] == refreshTToken){
      sessionStorage.setItem(key, token);
    }
  }
  if(this.isPopUp() || this.isChromeExtWin()){
    localStorage.setItem(Constants.STORAGE_KEY_REFRESH_TOKEN, token);
  }else{
    sessionStorage.setItem(Constants.STORAGE_KEY_REFRESH_TOKEN, token);
  }
};

global.getRefreshToken = function() {
  let token = sessionStorage.getItem(Constants.STORAGE_KEY_REFRESH_TOKEN) || localStorage.getItem(Constants.STORAGE_KEY_REFRESH_TOKEN) || '';
  return token;
};
global.setUserInfo = function(userInfo){
  try{
    localStorage.setItem(Constants.STORAGE_KEY_USER_INFO, JSON.stringify(userInfo));
  }catch (e) {
    localStorage.setItem(Constants.STORAGE_KEY_USER_INFO, JSON.stringify({}));
  }
};
global.getUserInfo = function() {
  try{
    let userInfo = JSON.parse(localStorage.getItem(Constants.STORAGE_KEY_USER_INFO));
    return userInfo || {};
  }catch (e) {
    return {};
  }
};
global.setParentAppHost = function(value) {
  let parentAppHost = '';
  if(value){
    try {
      parentAppHost = decodeURIComponent(value);
    }catch (e) {
      parentAppHost = null;
    }
  } else {
    parentAppHost = null;
  }
  if(parentAppHost){
    sessionStorage.setItem(Constants.STORAGE_KEY_PARENT_APP_HOST, parentAppHost);
  }
};

global.getParentAppHost = function() {
  return sessionStorage.getItem(Constants.STORAGE_KEY_PARENT_APP_HOST);
};

global.setParentNoTag = function(value) {
  this.parentNoTag = value;
};

global.isParentNoTag = function() {
  return this.parentNoTag === 'Y';
};

global.setAppPortalTarget = function(value) { //在门户中的标记，可以用于区分门户的广播消息，一般是在门户中的应用名称
  if(value){
    value = decodeURIComponent(value);
    sessionStorage.setItem(Constants.STORAGE_KEY_APP_PORTAL_TARGET, value);
  }
};

global.getAppPortalTarget = function() {
  return sessionStorage.getItem(Constants.STORAGE_KEY_APP_PORTAL_TARGET);
};

global.setMenuBarMode = function(value) { //在门户中的标记是否显示应用中心
  if(value){
    sessionStorage.setItem(Constants.STORAGE_KEY_MENU_BAR_MODE, value);
  }
};

global.getCrossEventBus = function(){
  return false;
};

global.setMenuHomeUrl = function(value) { //在门户中的标记是否显示应用中心
  if(value){
    sessionStorage.setItem(Constants.STORAGE_KEY_MENU_HOME_URL, value);
  }
};

global.getMenuHomeUrl = function() {
  return sessionStorage.getItem(Constants.STORAGE_KEY_MENU_HOME_URL);
};

global.setHideMenu = function(value) { //在门户中的标记是否显示应用中心
  if(value){
    sessionStorage.setItem(Constants.STORAGE_KEY_HIDE_MENU, value);
  }
};

global.getHideMenu = function() {
  return sessionStorage.getItem(Constants.STORAGE_KEY_HIDE_MENU);
};

global.setDocumentTitle = function(value) { //在门户中的标记是否显示应用中心
  if(value){
    sessionStorage.setItem(Constants.STORAGE_KEY_DOCUMENT_TITLE, value);
  }
};

global.getDocumentTitle = function() {
  return sessionStorage.getItem(Constants.STORAGE_KEY_DOCUMENT_TITLE);
};

global.setAppPortalId = function(value) { //在门户中的标记是否显示应用中心
  if(value){
    sessionStorage.setItem(Constants.STORAGE_KEY_APP_PORTAL_ID, value);
  }
};

global.getAppPortalId = function() {
  return sessionStorage.getItem(Constants.STORAGE_KEY_APP_PORTAL_ID);
};

global.addStorage = function(key, value, crossApp = false){
  let storageStr = localStorage.getItem(Constants.STORAGE_KEY_STORAGE);
  if(crossApp){
    storageStr = localStorage.getItem(Constants.STORAGE_KEY_STORAGE_CROSS_APP);
  }
  let storage = {};
  if(storageStr){
    try {
      storage = JSON.parse(storageStr);
    }catch (e) {
      console.error('addStorage>>>', e);
    }
  }
  if(!storage){
    storage = {};
  }
  storage[key] = value;
  if(crossApp){
    localStorage.setItem(Constants.STORAGE_KEY_STORAGE_CROSS_APP, JSON.stringify(storage));
  } else {
    localStorage.setItem(Constants.STORAGE_KEY_STORAGE, JSON.stringify(storage));
  }
};

global.getStorage = function(key, removeflag = true, crossApp = false){
  let storageStr = localStorage.getItem(Constants.STORAGE_KEY_STORAGE);
  if(crossApp){
    storageStr = localStorage.getItem(Constants.STORAGE_KEY_STORAGE_CROSS_APP);
  }
  let storage = {};
  if(storageStr){
    try {
      storage = JSON.parse(storageStr);
    }catch (e) {
      console.error('getStorage>>>', e);
    }
  }
  if(!storage){
    storage = {};
  }
  if(removeflag || crossApp){ //跨应用的一律立刻清除，避免浪费缓存
    this.removeStorage(key, crossApp);
  }
  return storage[key];
};

global.removeStorage = function(key, crossApp = false){
  let storageStr = localStorage.getItem(Constants.STORAGE_KEY_STORAGE);
  if(crossApp){
    storageStr = localStorage.getItem(Constants.STORAGE_KEY_STORAGE_CROSS_APP);
  }
  let storage = {};
  if(storageStr){
    try {
      storage = JSON.parse(storageStr);
    }catch (e) {
      console.error('removeStorage>>>', e);
    }
  }
  if(!storage){
    storage = {};
  }
   delete storage[key];
  if(crossApp){
    localStorage.setItem(Constants.STORAGE_KEY_STORAGE_CROSS_APP, JSON.stringify(storage));
  } else {
    localStorage.setItem(Constants.STORAGE_KEY_STORAGE, JSON.stringify(storage));
  }
};
global.getWebviewPage = function(){
   let pageStr = sessionStorage.getItem(Constants.STORAGE_KEY_WEBVIEW_PAGE);
   let result = {};
   if(pageStr){
     result = JSON.parse(pageStr);
   } else {
     result = this.getStorage(Constants.STORAGE_KEY_WEBVIEW_PAGE);
     sessionStorage.setItem(Constants.STORAGE_KEY_WEBVIEW_PAGE, JSON.stringify(result));
   }
   return result;
};

global.setWatermarkTxt = function(value) { //水印内容
  if(value){
    this.watermarkTxt = value;
  }
};

global.getWatermarkTxt = function() {
  return this.watermarkTxt || '';
};

global.setWatermarkSettings = function(value) { //水印内容
    if(value){
        this.watermarkSettings = value;
    }
};

global.getWatermarkSettings = function() {
  return this.watermarkSettings || {};
};

global.init = function (url) {
  let locationHref = window.location.href;
  if(locationHref.indexOf('kiaf_hash') >= 0){
    let index = locationHref.indexOf('kiaf_hash') + 'kiaf_hash'.length;
    let redirectPath = locationHref.substring(index).split('#')[0];
    window.location.href = Comm.getFullUrl(redirectPath);
    return;
  }
  return new Promise((resolve, reject) => {
    let env = this.getEnv();
    if(!url){
      url = Comm.getHost() + `/static/config/global-${env}.json?v=${new Date().getTime()}`;
    }
    axios.get(url).then((res) => {
      let params = res.data;
      if (params['CLOUD_RBAC_URL']) {
        this.setCloudRbacUrl(params['CLOUD_RBAC_URL']);
      }
      if (params['BASE_URL']) {
        this.setBaseUrl(params['BASE_URL']);
      }
      if (params['REFRESH_TOKEN_URL']) {
        this.setRefreshTokenUrl(params['REFRESH_TOKEN_URL']);
      }
      if (params['WINDOWS']) {
        this.setInitWindows(params['WINDOWS']);
        if(this.getWindows().length <= 0) { //避免刷新后保存的windows又被global-xxx.json覆写了,这样切换屏幕的时候，路由会有问题，因为登录时会清空缓存，所以对于首次加载不会有缓存问题
          this.setWindows(params['WINDOWS']);
        }
      }
      if (params['POPUP']) {
        this.setPopUp(params['POPUP']);
      }
      if (params['CLIENT_SIGN']) {
        this.setClientSign(params['CLIENT_SIGN']);
      }
      if (params['SECRET_KEY']) {
        this.setSecretKey(params['SECRET_KEY']);
      }
      if (params['MENU']) {
        this.setMenu(params['MENU']);
      }
      if (params['MENU_SIGN']) {
        this.setMenuSign(params['MENU_SIGN']);
      }
      if (params['MENU_TYPE']) {
        this.setMenuType(params['MENU_TYPE']);
      }
      if (params['CUSTOM_CONFIG']) {
        this.setCustomConfig(params['CUSTOM_CONFIG']);
      }
      if (params['CUSTOM_API']) {
        this.setCustomApi(params['CUSTOM_API']);
      }
      if (params['SKIP_LOGIN']) {
          this.setSkipLogin(params['SKIP_LOGIN']);
      }
      if (params['PRELOAD_MODE']) {
        this.setPreloadMode(params['PRELOAD_MODE']);
      }
      if (params['SHA_256']) {
        this.setSha256(params['SHA_256']);
      }
      if (params['STATIC_HOME_PAGE']) {
        this.setStaticHomePage(params['STATIC_HOME_PAGE']);
      }
      if (params['STATIC_MENU']) {
        this.setStaticMenu(params['STATIC_MENU']);
      }
      if (params['AJAX']) {
        axios.setConfig(params['AJAX']);
      } else {
        axios.setConfig(params, true);
      }
      let primaryWin = Comm.getUrlParam('primaryWin');
      if(primaryWin === 'Y'){
        this.setPrimaryWindow(primaryWin);
      }
      let chromeExtWin = Comm.getUrlParam('chromeExtWin');
      if(chromeExtWin === 'Y'){
        this.setChromeExtWin(chromeExtWin);
      }

      let windowId = Comm.getUrlParam('windowId') || window.name;
      if(!Comm.isEmpty(windowId)){
        this.setSessionWindowId(windowId);
        window.name = windowId;
      }

      let hideMenu = Comm.getUrlParam('hide_menu');// Y or internal
      if (!Comm.isEmpty(hideMenu)) {
        this.setHideMenu(hideMenu);
      }
      let subwindow = Comm.getUrlParam('subwindow');
      if (!Comm.isEmpty(subwindow)) {
        this.setSubWindow(true);
        this.setSessionWindowId(window.name || 'subwindow_' + new Date().getTime());
      }
      let documentTitle = Comm.getUrlParam('document_title');// Y or internal
      if (!Comm.isEmpty(documentTitle)) {
        this.setDocumentTitle(documentTitle);
      }
      let webviewMode = Comm.getUrlParam('webview_mode');

      if (!Comm.isEmpty(webviewMode)) {
        this.setWebviewMode(webviewMode);
        if(webviewMode.toUpperCase() === 'APPPORTAL'){
          let whiteList = [Constants.STORAGE_KEY_JWT_TOKEN, Constants.STORAGE_KEY_REFRESH_TOKEN, Constants.STORAGE_KEY_PARENT_APP_HOST, Constants.STORAGE_KEY_CUSTOM_CONFIG, Constants.STORAGE_KEY_WINDOWS, Constants.STORAGE_KEY_THEME];
          Comm.clearAppStorage(whiteList);
          if (params['WINDOWS']) { //app portal的模式下，刷新windows
            this.setWindows(params['WINDOWS']);
          }
        }
        let jwtToken = Comm.getUrlParam('jwt_token');
        let refreshToken = Comm.getUrlParam('refresh_token');
        let skipLogin = Comm.getUrlParam('skip_login');
        let username = Comm.getUrlParam('username');
        let tenantId = Comm.getUrlParam('tenantid'); // 租户 id，多租户情况下会使用到
        let logintime = Comm.getUrlParam('logintime');
        let parentAppHost = Comm.getUrlParam('parent_app_host');
        // let channelCode = Comm.getUrlParam('channel_code');
        let appPortalTarget = Comm.getUrlParam('app_portal_target');
        let menuHomeUrl = Comm.getUrlParam('menu_home_url');
        // let hideMenu = Comm.getUrlParam('hide_menu');
        let appPortalId = Comm.getUrlParam('app_portal_id');
        let internalPage = Comm.getUrlParam('internal_page');
        let parentNoTag = Comm.getUrlParam('parent_no_tag');
        let kiafTheme = Comm.getUrlParam('kiaf_theme');
        let popup = Comm.getUrlParam('popup');
        if (!Comm.isEmpty(popup)) {
          this.setPopUp(popup, true);//强制更新
        }
        if (!Comm.isEmpty(skipLogin)) {
          this.setSkipLogin(skipLogin);
        }
        if (!Comm.isEmpty(jwtToken)) {
          this.setJwtToken(jwtToken);
          if (location.href.indexOf('/kiaf/sso') > 0) { // 避免因为windows缓存而无法更新，正常的登录会清空缓存，但是门户大开的双屏没有登录，从而无法清空缓存
            this.setWindows(params['WINDOWS']);
          }
        }
        if (!Comm.isEmpty(username)) {
          let userinfo = this.getUserInfo();
          if(!userinfo.username){
            userinfo.username = username;
          }
          if (!Comm.isEmpty(logintime)) {
            userinfo.logintime = logintime;
          }
          this.setUserInfo(userinfo);
        }
        // 多租户模式下，链接里面传递了 tenantid 时，将其保存在userinfo 中
        if (this.getCustomConfig()['RBAC_MULTI_TENANT'] == 'Y' && !Comm.isEmpty(tenantId)) {
          let userinfo = this.getUserInfo();
          if (userinfo.user) {
            userinfo.user.tenantId = tenantId;
          } else {
            userinfo.user = {
              tenantId: tenantId
            }
          }
          this.setUserInfo(userinfo);
        }
        if (!Comm.isEmpty(parentNoTag)) {
          this.setParentNoTag(parentNoTag);
        }
        if (!Comm.isEmpty(refreshToken)) {
          this.setRefreshToken(refreshToken);
        }
        if (!Comm.isEmpty(parentAppHost)) {
          this.setParentAppHost(parentAppHost);
        }
        if (!Comm.isEmpty(appPortalTarget)) {
          this.setAppPortalTarget(appPortalTarget);
        }
        if (!Comm.isEmpty(menuHomeUrl)) {
          this.setMenuHomeUrl(menuHomeUrl);
        }
        if (!Comm.isEmpty(appPortalId)) {
          this.setAppPortalId(appPortalId);
        }
        if (!Comm.isEmpty(kiafTheme)) {
          // Constants.THEME_DEFAULT = kiafTheme;
          sessionStorage.setItem(Constants.STORAGE_KEY_THEME, kiafTheme);
        }
        if (!Comm.isEmpty(internalPage)) {
          let webviewPage = {
            id: new Date().getTime(),
            title: appPortalTarget,
            url: decodeURIComponent(internalPage)
          };
          this.addStorage(Constants.STORAGE_KEY_WEBVIEW_PAGE, webviewPage);
        }
      }
      resolve(true);
    }).catch((err) => {
      console.error('global init err', err);
      reject(true);
    });
  });
};

export default global;
